// import React, { useState } from "react";
// import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
// import { Link, NavLink } from "react-router-dom";
// import Client from "../../../utils/client";
// import { useQuery } from "@tanstack/react-query";

// function SideBar() {
//   const [toggled, setToggled] = useState(false);
//   const [broken, setBroken] = useState(
//     window.matchMedia("(max-width: 800px)").matches
//   );

//   // Fetch unread notifications count
//   const { data: unreadNotifications = 0 } = useQuery({
//     queryKey: ["unreadNotifications"],
//     queryFn: async () => {
//       const response = await Client.get(`/notifications/unread-count`);
//       return response.data;
//     },
//     refetchInterval: 5000, // Poll every 5 seconds
//   });

//   // Fetch unread messages count
//   const { data: unreadCount = 0 } = useQuery({
//     queryKey: ["unreadMessages"],
//     queryFn: async () => {
//       const response = await Client.get("/messages/unread-count");
//       return response.data.unreadCount;
//     },
//     refetchInterval: 5000, // Poll every 5 seconds
//   });

//   return (
//     <>
//       {/* <button
//         type="button"
//         className="inline-flex items-center fixed right-3 mt-3 border ml-2 w-15 z-50 text-sm text-gray-500 rounded-lg md:hidden lg:hidden"
//         onClick={() => setToggled(!toggled)}
//       >
//         <span className="sr-only">Open main menu</span>
//         <svg
//           className="w-8 h-9"
//           aria-hidden="true"
//           fill="#23AA49"
//           viewBox="0 0 20 20"
//           xmlns="http://www.w3.org/2000/svg"
//         >
//           <path
//             fillRule="evenodd"
//             d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
//             clipRule="evenodd"
//           ></path>
//         </svg>
//       </button> */}

//       <div
//         style={{
//           display: "flex",
//           height: "65vh",
//           direction: "rtl",
//         }}
//         className="border-l mt-10"
//       >
//         <Sidebar
//           rtl
//           backgroundColor="rgb(255, 255, 255)"
//           toggled={toggled}
//           customBreakPoint="800px"
//           onBreakPoint={setBroken}
//         >
//           {/* <div>
//             { localStorage.getItem("user_id")}
//           </div> */}
//           <Menu transitionDuration={1000} className="profile">
            
//             <NavLink to="/home/profile" end className="border-b pb-3">

//               <MenuItem>
//                 <div className="relative">
//                   <span>
//                     حسابي
//                   </span>
                 
//                 </div>
//               </MenuItem>


//             </NavLink>

//             <NavLink to="notifications" className="border-b pb-3">

//               <MenuItem>
//                 <div className="relative">
//                   <span>
//                     الاشعارات
//                   </span>
//                   {unreadNotifications > 0 && (
//                     <span className="absolute top-1 left-0 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
//                       {unreadNotifications}
//                     </span>
//                   )}
//                 </div>
//               </MenuItem>


//             </NavLink>

//             <NavLink to="negotiations" className="border-b pb-3 relative">
//               <MenuItem className="space-x-2 ">

//                 <div className="relative">
//                   <span>الرسائل</span>

//                   {unreadCount > 0 && (
//                     <span className="absolute top-1 left-0 bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full">
//                       {unreadCount}
//                     </span>
//                   )}

//                 </div>

//               </MenuItem>
//             </NavLink>


//             <NavLink to="my-orders" className="border-b pb-3">
//               <MenuItem>المشتريات</MenuItem>
//             </NavLink>

//             <NavLink to="my-sales" className="border-b pb-3">
//               <MenuItem>المبيعات</MenuItem>
//             </NavLink>

//             <NavLink to="invoices" className="border-b pb-3">
//               <MenuItem>الفواتير</MenuItem>
//             </NavLink>

//             <NavLink to="donations" className="border-b pb-3">
//               <MenuItem>عمليات مساهمة ثبات</MenuItem>
//             </NavLink>

//             <NavLink to="fav" className="border-b pb-3">
//               <MenuItem>المفضلة</MenuItem>
//             </NavLink>

//             <SubMenu label="المدخلات" className="border-b ">
//               <NavLink to="crops">
//                 <MenuItem>المحاصيل</MenuItem>
//               </NavLink>
//               <NavLink to="services">
//                 <MenuItem>الخدمات</MenuItem>
//               </NavLink>
//               <NavLink to="inputs">
//                 <MenuItem>مدخلات الإنتاج</MenuItem>
//               </NavLink>
//               <NavLink to="auctions">
//                 <MenuItem>المزادات</MenuItem>
//               </NavLink>
//             </SubMenu>
//             <SubMenu label="إعدادات الحساب" className="border-b ">
//               <NavLink to="change-phonenumber">
//                 <MenuItem>تغيير رقم الهاتف</MenuItem>
//               </NavLink>
//               <NavLink to="change-password">
//                 <MenuItem>تغيير كلمة المرور</MenuItem>
//               </NavLink>
//               <NavLink to="update-info">
//                 <MenuItem>تعديل الملف الشخصي</MenuItem>
//               </NavLink>
//             </SubMenu>
//           </Menu>
//         </Sidebar>
//       </div>
//     </>
//   );
// }

// export default SideBar;
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Link, NavLink } from "react-router-dom";
import Client from "../../../utils/client";
import { useQuery } from "@tanstack/react-query";

function SideBar() {
  const { t, i18n } = useTranslation();
  const userType = localStorage.getItem("type");
  const cooprativeType = localStorage.getItem("cooprativeType");
  console.log("User type from localStorage:", userType); // Debugging line
  console.log("Cooperative type from localStorage:", cooprativeType); // Debugging line
  const isRtl = i18n.language === 'ar';
  const [toggled, setToggled] = useState(false);
  const [broken, setBroken] = useState(
    window.matchMedia("(max-width: 800px)").matches
  );

  const isRTL = i18n.language === 'ar';

  // Fetch unread notifications count
  const { data: unreadNotifications = 0 } = useQuery({
    queryKey: ["unreadNotifications"],
    queryFn: async () => {
      const response = await Client.get(`/notifications/unread-count`);
      return response.data;
    },
    refetchInterval: 5000, // Poll every 5 seconds
  });

  // Fetch unread messages count
  const { data: unreadCount = 0 } = useQuery({
    queryKey: ["unreadMessages"],
    queryFn: async () => {
      const response = await Client.get("/messages/unread-count");
      return response.data.unreadCount;
    },
    refetchInterval: 5000, // Poll every 5 seconds
  });

  return (
    <>
      <div
        style={{
          display: "flex",
          height: "65vh",
          direction: i18n.language === 'ar' ? 'rtl' : 'ltr',
        }}
        className="border-l mt-10"
      >
        <Sidebar
          // rtl={i18n.language === 'ar'}
          backgroundColor="rgb(255, 255, 255)"
          toggled={toggled}
          customBreakPoint="800px"
          onBreakPoint={setBroken}
        >
          <Menu transitionDuration={1000} className="profile">
            
            <NavLink to="/home/profile" end className="border-b pb-3">
              <MenuItem>
                <div className="relative">
                  <span>{t("sidebar.myAccount")}</span>
                </div>
              </MenuItem>
            </NavLink>

            <NavLink to="notifications" className="border-b pb-3">
              <MenuItem>
                <div className="relative">
                  <span>{t("sidebar.notifications")}</span>
                  {unreadNotifications > 0 && (
                    <span className={`absolute top-1 ${isRtl ? 'left-0' : 'right-0' } bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full`}>
                      {unreadNotifications}
                    </span>
                  )}
                </div>
              </MenuItem>
            </NavLink>

            <NavLink to="negotiations" className="border-b pb-3 relative">
              <MenuItem className="space-x-2">
                <div className="relative">
                  <span>{t("sidebar.messages")}</span>
                  {unreadCount > 0 && (
                    <span className={`absolute top-1 ${isRtl ? 'left-0' : 'right-0' } bg-red-500 text-white text-xs font-bold w-5 h-5 flex items-center justify-center rounded-full`}>
                      {unreadCount}
                    </span>
                  )}
                </div>
              </MenuItem>
            </NavLink>

            <NavLink to="my-orders" className="border-b pb-3">
              <MenuItem>{t("sidebar.purchases")}</MenuItem>
            </NavLink>

            <NavLink to="salat-orders" className="border-b pb-3">
              <MenuItem>{t("sidebar.salatOrders")}</MenuItem>
            </NavLink>

            <NavLink to="my-sales" className="border-b pb-3">
              <MenuItem>{t("sidebar.sales")}</MenuItem>
            </NavLink>

            {/* <NavLink to="invoices" className="border-b pb-3">
              <MenuItem>{t("sidebar.invoices")}</MenuItem>
            </NavLink> */}

            <NavLink to="donations" className="border-b pb-3">
              <MenuItem>{t("sidebar.donations")}</MenuItem>
            </NavLink>

            <NavLink to="fav" className="border-b pb-3">
              <MenuItem>{t("sidebar.favorites")}</MenuItem>
            </NavLink>

            <SubMenu label={t("sidebar.inputs")} className="border-b">
              <NavLink to="crops">
                <MenuItem>{t("sidebar.crops")}</MenuItem>
              </NavLink>
              <NavLink to="services">
                <MenuItem>{t("sidebar.services")}</MenuItem>
              </NavLink>
              <NavLink to="inputs">
                <MenuItem>{t("sidebar.inputProducts")}</MenuItem>
              </NavLink>
              <NavLink to="auctions">
                <MenuItem>{t("sidebar.auctions")}</MenuItem>
              </NavLink>
            </SubMenu>

            <SubMenu label={t("sidebar.accountSettings")} className="border-b">
              <NavLink to="change-phonenumber">
                <MenuItem>{t("sidebar.changePhoneNumber")}</MenuItem>
              </NavLink>
              <NavLink to="change-password">
                <MenuItem>{t("sidebar.changePassword")}</MenuItem>
              </NavLink>
              <NavLink to="update-info">
                <MenuItem>{t("sidebar.editProfile")}</MenuItem>
              </NavLink>
            </SubMenu>
          </Menu>
        </Sidebar>
      </div>
    </>
  );
}

export default SideBar;